export const getTaskStatus = (state) => state.status
